/**
 * localStorage key under which the AI thread timestamp-format preference
 * persists. The provider derives its precision and per-thread anchor keys from
 * this one, so changing the value orphans those stored preferences too.
 */
export const AGENT_THREAD_TIME_FORMAT_STORAGE_KEY =
  "roboto-ai-agent-thread-time-format";
